import { createContext, useContext, useEffect, useState } from 'react';

import { referredByVet } from '@farmersdog/lead-browser-storage';

import { useReferredByVetUrlParam } from '../useReferredByVetUrlParam';

import type { ReferredByVet } from '../useReferredByVetUrlParam';
import type { ReactNode } from 'react';

export type VetCustomPlanContextType = ReferredByVet | undefined;

const VetCustomPlanContext = createContext<VetCustomPlanContextType>(undefined);

interface VetCustomPlanContextProviderProps {
  children: ReactNode;
}

export function VetCustomPlanContextProvider({
  children,
}: VetCustomPlanContextProviderProps) {
  const [contextValue, setContextValue] =
    useState<VetCustomPlanContextType>(undefined);

  const referredByVetData = useReferredByVetUrlParam();
  // look for query params in the URL referredByVet
  // if exists, parse the values and set them in the context & session storage
  // if not, set the context to undefined

  useEffect(() => {
    if (referredByVetData) {
      referredByVet.set(JSON.stringify(referredByVetData));
      setContextValue(referredByVetData);
    }
  }, [referredByVetData]);

  return (
    <VetCustomPlanContext.Provider value={contextValue}>
      {children}
    </VetCustomPlanContext.Provider>
  );
}

export function useVetCustomPlanContext(): VetCustomPlanContextType {
  const contextValue = useContext(VetCustomPlanContext);

  if (contextValue === null) {
    throw new Error(
      'VetCustomPlanProvider must be used within a VetCustomPlanContextProvider'
    );
  } else {
    return contextValue;
  }
}
